{
  "id": 48,
  "location": "paris",
  "difficulty": "hard",
  "moves": 31,
  "kinds": 6,
  "goals": [
    { "type": "stain" },
    { "type": "collect", "kind": "macaron", "count": 44 }
  ],
  "stars": [4810, 5950],
  "board": [
    ". . . . . . . .",
    ". ~. ~. ~. ~. ~. ~. .",
    ". . ~. ~. ~. ~. . .",
    ". . . # # . . .",
    ". . . # # . . .",
    ". . ~. ~. ~. ~. . .",
    ". ~. ~. ~. ~. ~. ~. .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.493, "movesLeft": 5.5, "closeLosses": 0.139, "target": 0.5 }
}
